import React from "react";
import Row from "@visa/vds/row";
import Col from "@visa/vds/col";
import Typography from "@visa/vds/typography";

const ManageSubscriptionDisclaimer = (props) => {
    return (
        <>
            <Row>
                <Col>
                    <Typography className="vss-field-label">
                        VSTS fees are one-time charges. One time charges cannot be canceled.
                    </Typography>
                    <Typography className="vss-field-label">
                        VSTT fees include one-time charges and recurring fees. Only VSTT recurring fees can be canceled.
                    </Typography>
                </Col>
            </Row>
        </>
    );
};

export default ManageSubscriptionDisclaimer;
